/**
 * Constructs the URL for a profile picture.
 *
 * This utility provides a single point for profile picture URL generation,
 * supporting both backend-provided URLs (from CloudFront/S3) and local fallback.
 *
 * @param userId - The user's ID
 * @param avatarVersion - The avatar version number (null if no avatar)
 * @param profilePictureUrl - Optional URL from backend (preferred if available)
 * @returns The profile picture URL, or null if no avatar exists
 */
export function getProfilePictureUrl(
	userId: string,
	avatarVersion: number | null | undefined,
	profilePictureUrl?: string | null
): string | null {
	// If no avatar version, there's no profile picture
	if (!avatarVersion) {
		return null;
	}

	// Prefer backend-provided URL (from CloudFront/S3 based on environment)
	if (profilePictureUrl) {
		return profilePictureUrl;
	}

	// Fallback: construct URL locally (for backwards compatibility)
	return `${process.env.REACT_APP_URL}/images/profiles/${userId}/v${avatarVersion}.jpg`;
}
